import React, {useEffect, useState} from 'react';
import {AutoComplete, Button, Card, Empty, Form, Input, Select, Typography} from 'antd';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';
import './applicationTemplate.scss';

ApplicationTemplate.propTypes = {
    template: PropTypes.array
};

function ApplicationTemplate(props) {
    const { template, form } = props
    const { Option } = Select;
    const { Text } = Typography;
    const [optionalType, setOptionalType] = useState({});
    const [selected, setSelected] = useState([]);
    const [hasSelect, setHasSelect] = useState(false);
    const [filterKey, setFilterKey] = useState([]);
    const [timeSlotDisables, setTimeSlotDisables] = useState({})

    useEffect(() => {
        if (template) {
            const type = template.find(e => e.type === 'optionalMultipleChoice')

            if (type) {
                setFilterKey([type.filter.sectionId, type.filter.fieldId])
                setOptionalType(type.format.reduce((cateList, cate) => ({
                    ...cateList,
                    [cate.id]: {
                        name: cate.name,
                        filter: cate.filter,
                        required: !cate.optional,
                        select: type.choices.reduce((choices, choice) => ({
                            ...choices,
                            [choice.id]: {
                                name: choice.name,
                                option: cate.choices.filter(e => e.available.includes(choice.id)).reduce((acc, curr) => ({
                                    ...acc,
                                    [curr.id]: curr.name
                                }), {})
                            }
                        }), {})
                    }
                }), {}))

                if(form.getFieldValue(type.id)){
                    setSelected(Object.keys(form.getFieldValue(type.id)))
                }
            }
        }

    }, [template, form])

    function onAdd() {
        setSelected( prev => [...prev, form.getFieldValue('add')]);
        form.setFieldsValue({add: undefined})
        setHasSelect(false)
    }
    function onDel(id) {
        return () => {
            let copy = [...selected]
            if(copy.indexOf(id) > -1){
                copy.splice(copy.indexOf(id), 1)
            }
            setSelected(copy)
        }
    }
    function sectionElement(section) {
        switch(section.type){
            case 'profile':
                return <div className='form-flex-container'>{profileElement(section.id, section.format)}</div>
            case 'optionalMultipleChoice':
                return optionalMultipleChoiceElement(section)
            case 'mandatorySingleChoice':
                return mandatorySingleChoiceElement(section.id, section.format)
            default: return <></>;
        }

    }
    function profileElement(sectionId, elements) {
        let elementItem = null
        return elements.map((element, i) => {
            switch(element.type) {
                case 'text': // Input text / With dropdown (AutoComplete)
                    let options = []
                    if(element.suggestion){
                        options = element.suggestion.map(option => {
                            return {
                                'value': option
                            }
                        })
                    }
                    elementItem = element.suggestion ?
                        // With dropdown
                        <AutoComplete
                            options={options}
                            placeholder={element.name}

                        /> :
                        // Input free text
                        <Input
                            placeholder={element.name}
                        />
                    break;
                case 'singleChoice':
                    const singleOption = element.choices.map((option, j) => {
                        return (
                            <Option
                                key={j}
                                id={option.id}
                                value={option.id}
                            >
                                {option.name}
                            </Option>
                        )
                    })// Select
                    elementItem =
                        <Select
                            placeholder={element.name}
                        >
                            {singleOption}
                        </Select>
                    break;
                case 'phone': // Input tel & number only
                    elementItem =
                        <Input
                            placeholder='聯絡電話'
                            type='tel'
                            pattern='[0-9]{8}'
                            onInput={(e)=> { e.target.setCustomValidity(''); if(!e.target.validity.valid) e.target.setCustomValidity('請輸入八位數字有效之電話號碼')}}
                        />
                    break;
                case 'RestfulEmailInput':
                    elementItem = <Input
                        placeholder='電郵地址'
                        type='email'
                        onInput={(e)=> { e.target.setCustomValidity(''); if(!e.target.validity.valid) e.target.setCustomValidity('請輸入有效之電郵地址')}}
                    />
                    break;
                default:
                    return <></>
            }

            return (
                <Form.Item
                    key={i}
                    id={element.id}
                    label={element.name}
                    name={[sectionId, element.id]}
                    rules={[{ required: !element.optional, message: '請填入資料' }]}
                >
                    { elementItem }
                </Form.Item>
            )
        })
    }
    function optionalMultipleChoiceElement(section) {
        return (
            <>
                {selected.length > 0 && (<Form.Item
                    shouldUpdate={(prevValues, curValues) => {
                            if(prevValues[filterKey[0]] && prevValues[filterKey[0]][filterKey[1]] !== curValues[filterKey[0]][filterKey[1]]) {
                                setSelected([])
                                return true
                            }
                            return false
                        }
                    }
                >
                    {() => {
                        return selected.map((cateId, i) => {
                            const matchedObj = optionalType[cateId]

                            return (
                                <Form.Item
                                    key={i}
                                    id={cateId}
                                    name={cateId}
                                >
                                    <Card
                                        title={matchedObj.name}
                                        extra={
                                            (<a className='del-button' onClick={onDel(cateId)}>
                                                <MinusOutlined/> 刪除課程
                                            </a>)
                                        }
                                    >
                                        { Object.keys(matchedObj.select).map((selection, j)=> {
                                            return (
                                                <Form.Item
                                                    key={j}
                                                    id={selection}
                                                    className='inline-selection'
                                                    label={matchedObj.select[selection].name}
                                                    name={[section.id, cateId, selection]}
                                                    validateTrigger='onSubmit'
                                                    rules={[
                                                        { required: matchedObj.required, message: `請選擇${matchedObj.select[selection].name}` },
                                                    ]}

                                                >
                                                    <Select
                                                        placeholder={matchedObj.select[selection].name}
                                                        onChange={(e) => setTimeSlotDisables({...timeSlotDisables, [`${section.id}${cateId}${selection}`]: e })}
                                                    >
                                                        { Object.keys(matchedObj.select[selection].option).map((option, l)=>{
                                                            return (
                                                                <Option
                                                                    key={l}
                                                                    id={option}
                                                                    value={option}
                                                                    disabled={Object.values(timeSlotDisables).includes(option) }
                                                                >
                                                                    {matchedObj.select[selection].option[option]}
                                                                </Option>
                                                            )
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                            )
                                        })}
                                    </Card>
                                </Form.Item>
                            )
                        })
                    }}
                </Form.Item>)}


                {selected.length === 0 &&
                    (<Empty description={false} />)
                }
                {
                    Object.keys(optionalType).length - selected.length > 0 &&
                        (
                            <div className='add-card'>

                                <Form.Item shouldUpdate>
                                    {() => {
                                        return (
                                            <Form.Item
                                                className='select-to-add'
                                                name='add'
                                                validateTrigger='onSubmit'
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(rule, value) {
                                                            if (selected.length > 0) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject('請選擇至少一個課程');
                                                        },
                                                    })
                                                ]}
                                            >
                                                <Select
                                                    placeholder='請選擇課程'
                                                    onChange={() => setHasSelect(true)}
                                                >
                                                    {
                                                        Object.keys(optionalType).filter(e => optionalType[e].filter === form.getFieldValue(filterKey)).filter(e => !selected.includes(e)).map((key) => {
                                                            return  (
                                                                <Option
                                                                    key={key}
                                                                    value={key}
                                                                    title={key}
                                                                >
                                                                    {optionalType[key].name}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>);
                                    }}
                                </Form.Item>

                                <Button disabled={!hasSelect} onClick={onAdd}><PlusOutlined />{section.addButtonName}</Button>
                            </div>
                        )
                }

            </>
        )
    }
    function mandatorySingleChoiceElement(sectionId, elements) {
        return elements.map((element, i) => {
            return (
                <Form.Item
                    key={i}
                    id={element.id}
                    className='inline-selection'
                    label={element.name}
                    name={[sectionId, element.id]}
                    rules={[{ required: !element.optional, message: `請選擇${element.name}` }]}
                >
                    <Select
                        placeholder={element.name}
                    >
                        {
                            element.choices.map((option, i) => {
                                return (
                                    <Option
                                        key={i}
                                        id={option.id}
                                        disabled={option.disabled}
                                        value={option.id}
                                    >
                                        {option.name}
                                    </Option>
                                )
                            })
                        }
                    </Select>
                </Form.Item>
            )
        })
    }
    
    return (
        <div className='application-template'>
            {
                template.map((section) => {
                    let htmlDescription
                    if(section.description){htmlDescription = { __html: section.description}}
                    return (
                        <Card key={section.id} title={
                            <>
                                {section.title}
                                {section.description && <Text className='description'><span className='text-area-description' dangerouslySetInnerHTML={htmlDescription}/></Text>}
                            </>
                        }>
                            { sectionElement(section) }
                        </Card>

                    )
                })
            }
        </div>
    )
}

export default ApplicationTemplate;
